<template>
  <div v-if="cockpitReport" id="dashboard-analytics">
    <div
      class="vs-row mt-5"
      id="report-wrapper"
      :class="{ hidden: !hasAppliedFilter && cockpitReport.venueFilter }"
    >
      <section id="report-container" class="embed-container"></section>
      <!-- Used to display report embed error messages -->
      <section class="error-container m-5"></section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import * as powerbi from 'powerbi-client';
export default {
  data() {
    return {
      cockpitReportId: "",
      workspaceId: "",
      reportId: "",
      filterTable: "df_id_master",
      filterColumn: "id_planday_new",
      filterValue: "",
      hasAppliedFilter: false,
      cockpitReport: null,
      report: null,
    };
  },
  components: {},
  methods: {
    async loadReport() {
      this.$vs.loading();
      await this.$store.dispatch("powerBi/getReportDetails", {
        reportId: this.reportId,
        workspaceId: this.workspaceId,
      });

      console.log("Got report details: ", this.reportDetails);
      let reportContainer = document.getElementById("report-container");

      //let powerbi = window["powerbi-client"];
      let models = window["powerbi-client"].models;

      powerbi.bootstrap(reportContainer, { type: "report" }); // eslint-disable-line
      const embedData = this.reportDetails;

      let pageSize = {
        type: models.PageSizeType.Custom,
        width: 300,
        height: 580,
      };

      // Create a config object with type of the object, Embed details and Token Type
      let reportLoadConfig = {
        type: "report",
        tokenType: models.TokenType.Embed,
        accessToken: embedData.EmbedToken.Token,

        embedUrl: embedData.EmbedReport[0].EmbedUrl,

        // Enable this setting to remove gray shoulders from embedded report
        settings: {
          background: models.BackgroundType.Transparent,
          layoutType: models.LayoutType.Custom,
          pageSize: pageSize,
          customLayout: {
            //pageSize: pageSize,
            displayOption: models.DisplayOption.FitToWidth, // FitToWidth
          },
        },
      };

      console.log("Powerbi config", reportLoadConfig);

      // Use the token expiry to regenerate Embed token for seamless end user experience
      // Refer https://aka.ms/RefreshEmbedToken
      const tokenExpiry = embedData.EmbedToken.Expiration;

      // Embed Power BI report when Access token and Embed URL are available
      this.report = powerbi.embed(reportContainer, reportLoadConfig); // eslint-disable-line

      // Clear any other loaded handler events
      this.report.off("loaded");

      // Triggers when a report schema is successfully loaded
      this.report.on("loaded", () => {
        this.applyFilter();
        console.log("Report load successful");
      });

      // Clear any other rendered handler events
      this.report.off("rendered");

      // Triggers when a report is successfully embedded in UI
      this.report.on("rendered", function () {
        console.log("Report render successful");
      });

      // Clear any other error handler events
      this.report.off("error");

      // Handle embed errors
      this.report.on("error", function (event) {
        let errorMsg = event.detail;
        console.error(errorMsg);
        return;
      });
    },
    async applyFilter() {
      if (!this.cockpitReport.venueFilter) {
        this.$vs.loading.close();
        console.log("No filter required");
        return;
      }
      console.log("Applying filters. Venues:", this.filterVenues);

      let models = window["powerbi-client"].models;
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: this.filterTable,
          column: this.filterColumn,
        },
        operator: "In",
        values: this.filterVenues,
      };

      // Add the filter to the report's filters.
      try {
        await this.report.updateFilters(models.FiltersOperations.Replace, [
          filter,
        ]); // Add
        this.hasAppliedFilter = true;
        console.log("Report filter was added.");
      } catch (errors) {
        console.log(errors);
      }
      this.$vs.loading.close();
    },
  },
  computed: {
    ...mapGetters({
      venues: "venues/venues",
      reportDetails: "powerBi/reportDetails",
    }),
    filterVenues() {
      return this.venues.map(
        (e) => "" + (e.isFromNewPlanday ? e.newDepartmentId : e.plandayPortalId)
      );
    },
    filterVenuesDesc() {
      return this.venues.map(
        (e) =>
          `(${e.name}: ${
            e.isFromNewPlanday ? e.newDepartmentId : e.plandayPortalId
          })`
      );
    },
  },
  async created() {},
  async mounted() {
    this.cockpitReportId = this.$route.params.id;
    await this.$store.dispatch("cockpitReports/getAll", false);

    //this.$vs.loading();
    this.cockpitReport = this.$store.getters["cockpitReports/cockpitReport"](
      this.cockpitReportId
    );

    console.log(
      "Loading report for ",
      this.cockpitReportId,
      this.cockpitReport
    );
    this.workspaceId = this.cockpitReport.workspaceId;
    this.reportId = this.cockpitReport.reportId;

    this.loadReport();
    // todo load report
    //this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
hidden {
  display: none;
}
/* iframe's parent node */
.content-wrapper {
  position: relative;
  height: 1px;

  .router-view {
    height: 100%;
    .router-content {
      height: 100%;
      .content-area__content {
        height: 100%;
      }
    }
  }
}

#dashboard-analytics {
  height: 100%;
  display: flex;
  flex-direction: column;

  #report-wrapper {
    position: relative;
    flex: 2;
    margin-bottom: 52px;

    #report-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}

/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>